import React from 'react';
import SensorDropdown from '../Dashboard/Sensor/SensorDropdown';
import {Sensor} from '../Common/Types/Sensor';
import {ICellRendererParams} from 'ag-grid-enterprise';

export function HamburgerMenu(props: ICellRendererParams<Sensor>) {
	return props.data && <SensorDropdown sensor={props.data} />;
}
